import styled from 'styled-components';

const StyledCountrySelector = styled.div`
  position: relative;
  z-index: 995;
  display: flex;
  justify-content: center;
`;

export default StyledCountrySelector;
